module.exports = __webpack_public_path__ + "img/gamepad-modern.22c94234.svg";